#import "../TravelAuthorizationListFields.graphql"

mutation TravelAuthorizationCreate($input: TravelAuthorizationCreateInput!) {
  travelAuthorizationCreate(input: $input) {
    travelAuthorization {
      ...TravelAuthorizationListFields
      corporateWorkgroupId
    }
  }
}
